import { render, staticRenderFns } from "./Workbar.vue?vue&type=template&id=385afc0f&"
import script from "./Workbar.vue?vue&type=script&lang=ts&"
export * from "./Workbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports